import { fromJS } from 'immutable'

const initialState = fromJS({
  list: [],
  authList: []
})

const myapps = (state = initialState, action) => {
  switch (action.type) {
    case "SET_MY_APPS":
      return state.merge({
        list: action.payload
      })
    case "SET_MY_AUTH_APPS":
      return state.merge({
        authList: action.payload
      })
    default:
      return state
  }
}

export default myapps